import { Form, Formik, FormikValues } from 'formik';
import React, { useEffect, useRef } from 'react';
import * as Yup from 'yup';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';

import FormikButton from '../../common/formik/FormikButton';
import FormikGrid from '../../common/formik/FormikGrid';
import FormikTextField from '../../common/formik/FormikTextField';
import { useCreateDocumentFolder } from './Document.hook';
import { FileDto, CreateFolderDto } from './Document.interface';

export interface DocumentCreateFolderDialogProps {
  folderDocumentId?: number;
  open: boolean;
  onCancel?: () => void;
  onCreated?: (folder: FileDto) => void;
}

const DocumentCreateFolderDialog: React.FC<DocumentCreateFolderDialogProps> = ({
  folderDocumentId,
  open,
  onCancel,
  onCreated
}) => {
  const formikRef = useRef<FormikValues>();
  const [{ data, isLoading, error }, createFolder] = useCreateDocumentFolder();
  useEffect(() => {
    console.log(error);
    if (!isLoading) {
      if (onCreated && data) {
        onCreated(data);
      }
      if (formikRef && formikRef.current) {
        formikRef.current.setSubmitting(false);
      }
    }
  }, [isLoading, onCreated, data, error]);
  return (
    <Dialog open={open} onClose={onCancel}>
      <Formik
        innerRef={(formik: any) => (formikRef.current = formik)}
        initialValues={{ name: '' }}
        validationSchema={Yup.object({
          name: Yup.string().required('Required')
        })}
        onSubmit={(folderDto: CreateFolderDto) => {
          folderDto.parentId = folderDocumentId;
          createFolder(folderDto);
        }}
      >
        <Form autoComplete='off'>
          <DialogTitle>New Folder</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Specify the name of the folder.
            </DialogContentText>
            <FormikGrid>
              <FormikTextField
                autoFocus
                type='text'
                name='name'
                label='Folder Name'
              />
            </FormikGrid>
            {error && (
              <Alert severity='error'>
                {error.message ||
                  'Error occurred. Please check your internet connection and try again.'}
              </Alert>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={onCancel}>Cancel</Button>
            <FormikButton>Create</FormikButton>
          </DialogActions>
        </Form>
      </Formik>
    </Dialog>
  );
};

export default DocumentCreateFolderDialog;
